'use strict'
import axios from 'axios'
import { ui } from '~/misc/Utils'
import { on } from 'delegated-events'

export default class CollectionProductTile {
    constructor() {
        this.bindEvents()
    }

    bindEvents() {
        on('click', '.quantity-btn', this.handleQuantityBtnClick.bind(this))
        on('click', '.product-variant-option', this.handleVariantOptionClick.bind(this))
        on('click', '.add-to-basket', this.handleAddToBasketClick.bind(this))
    }

    handleQuantityBtnClick(event) {
        event.preventDefault()
        const quantityInput = event.target.parentElement.querySelector('.quantity')
        const quantity = parseInt(quantityInput.value)
        const action = event.target.dataset.action

        console.log('button clicked')

        if (action === 'descrease') {
            if (quantity > 1) {
                quantityInput.value = quantity - 1
            }
        }

        if (action === 'increase') {
            const maxQuantity = parseInt(quantityInput.getAttribute('max'))
            if (quantity < maxQuantity) {
                quantityInput.value = quantity + 1
            } else {
                ui.toast('You have reached the maximum quantity', 'error')
            }
        }
    }

    handleVariantOptionClick(event) {
        const id = event.target.dataset.productId
        const price = event.target.dataset.price
        const comparePrice = event.target.dataset.comparePrice
        const variantId = event.target.getAttribute('id')
        const maxQuantity = event.target.dataset.max
        const discount = event.target.dataset.discount == 'true'
        const productCard = document.getElementById(`product-${id}`)

        if (productCard) {
            const productInput = productCard.querySelector('.product-id')
            const quantityInput = productCard.querySelector('.quantity')
            const productPrice = productCard.querySelector('.js-product-price')
            productInput.value = variantId
            quantityInput.value = 1
            quantityInput.setAttribute('max', maxQuantity)
            productPrice.innerHTML = price

            if (discount) {
                productPrice.innerHTML = `
                    <h4 class="text-25 font-bold xl-alt:font-medium capitalize text-bright-red leading-5">
                        ${price}
                    </h4>
                    <span class="text-16 font-normal capitalize text-medium-grey leading-none tracking-08 line-through">
                        ${comparePrice}
                    </span>
                `
            } else {
                productPrice.innerHTML = `
                    <h4 class="text-25 font-medium capitalize text-primary-dark-navy leading-5">
                        ${price}
                    </h4>
                `
            }
        }
    }

    handleAddToBasketClick(event) {
        event.preventDefault()
        const form = event.target.closest('form')

        if (form) {
            const productId = form.querySelector('.product-id').value
            const quantity = form.querySelector('.quantity').value

            const payload = {
                items: [
                    {
                        id: parseInt(productId),
                        quantity: parseInt(quantity),
                    },
                ],
            }

            event.target.disabled = true

            axios
                .post('/cart/add.js', payload)
                .then((response) => {
                    events.publish('cart')

                    setTimeout(() => {
                        events.publish('open-panel')
                    }, 500)
                })
                .catch((error) => {
                    console.log(error.response.data)
                })
                .finally(() => {
                    event.target.disabled = false
                })
        }
    }
}
